// extracted by mini-css-extract-plugin
module.exports = {"root":"GenericHero_root__HB6ov","desktopMaskedImage":"GenericHero_desktopMaskedImage__RFVgt","mobileMaskedImage":"GenericHero_mobileMaskedImage__TTo4i"};